import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { OffsetTopOne, OffsetTopThree, OffsetTopTwo } from "../../component/body/body";
import { typo } from '../../styles/style';
import ClickButtonAtom from '../atoms/ClickButtonAtom';
import ImgAtom from '../atoms/ImgAtom';

const HeaderOuter = styled.div`
display: flex;
 width: 100%;
 height: auto;
 justify-content: center;
 position: fixed;
 z-index: 2;
 background: #fff;
`
const Header = styled.div`
  display: flex;
  width: 80%;
  height: auto;
  justify-content: space-between;
  ${({ theme }) => theme.media.tablet`
  justify-content: space-around;
    `}
  ${({ theme }) => theme.media.mobile`
  align-items: center;
  flex-direction: column;
    `}
`;
const RightHeader = styled.div`
  display: flex;
  width: 27%;
  height: auto;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.media.tablet`
  width: 50%;
    `}
  ${({ theme }) => theme.media.mobile`
  width: 100%;
  height: 30px;
  padding-bottom: 15px;
    `}
`;
const LeftHeader = styled.div`
  display: flex;
  width: auto;
  height: auto;
  justify-content: flex-start;
  align-items: center;
  ${({ theme }) => theme.media.tablet`
  width: 50%;
    `}
  ${({ theme }) => theme.media.mobile`
margin-right: 45px;
    `}
`;

function OffsetTop () {
    window.scroll({
      behavior: "smooth",
      top: 0,
    });
}


class HeaderNavigationMolecule extends PureComponent {
    
    constructor(props) {
      super(props);
      this.state = {};
    }

    render() {


      return (
        <HeaderOuter>
          <Header>
            <LeftHeader>
              <ImgAtom
                width="205px"
                src="../images/logo.png"
                cursor="pointer"
                onClick={OffsetTop}
              />
            </LeftHeader>
            <RightHeader>
              <ClickButtonAtom
                typo={typo.header.h3}
                color={this.props.colorOne}
                onClick={OffsetTopOne}
                className="headerTeam header"
                text="Team"
              />
              <ClickButtonAtom
                typo={typo.header.h3}
                color={this.props.colorTwo}
                onClick={OffsetTopTwo}
                className="headerProject header"
                text="Project"
              />
              <ClickButtonAtom
                typo={typo.header.h3}
                color={this.props.colorThree}
                onClick={OffsetTopThree}
                className="headerContact header"
                text="Contact"
              />
            </RightHeader>
          </Header>
        </HeaderOuter>
      );
    }
  }


  export default HeaderNavigationMolecule;